import type { DirectorLanguage, DirectorVisual } from '@clutch/core';
import { COURT, feedToCourt } from '../stage/court';
import { locatedShot } from './moment-presentation';
import { pick } from './i18n';

/** A static source location. No implied trajectory, optical tracking, or made-up surrounding plays. */
export function MomentVisual({ visual, language }: { visual: DirectorVisual; language: DirectorLanguage }) {
  if (!locatedShot(visual)) return null;
  const point = feedToCourt(visual.x, visual.y);
  const label = pick({ en: 'Recorded shot location', hi: 'दर्ज शॉट की जगह', zh: '记录的出手位置' }, language);
  const made = visual.made === true;
  const missed = visual.made === false;
  const result = made && visual.points ? `+${visual.points}` : missed ? pick({ en: 'Miss', hi: 'चूका', zh: '未命中' }, language) : undefined;
  return <figure className="moment-visual" data-testid="moment-visual" data-event-id={visual.eventId} data-seq={visual.seq} data-side={visual.side ?? 'none'}>
    <svg viewBox="-1 -1 96 52" role="img" aria-label={label}>
      <rect className="moment-visual__floor" width={COURT.length} height={COURT.width} rx="1" />
      <g className="moment-visual__lines">
        <path d="M47 0V50" /><circle cx="47" cy="25" r="6" />
        {[false, true].map((flip) => <g key={String(flip)} transform={flip ? 'translate(94 0) scale(-1 1)' : undefined}>
          <path d="M0 17H19V33H0M4 22V28M0 3H14A23.75 23.75 0 0 1 14 47H0" />
          <circle cx="19" cy="25" r="6" /><circle cx="5.25" cy="25" r="0.75" />
        </g>)}
      </g>
      <circle className="moment-visual__halo" cx={point.x} cy={point.y} r="4" />
      <circle className={`moment-visual__point${made ? ' is-made' : ''}`} cx={point.x} cy={point.y} r="1.8" />
    </svg>
    <figcaption><span>{label}</span>{result && <b>{result}</b>}</figcaption>
  </figure>;
}
